import { useEffect } from 'react';
import pt from 'prop-types';
import { isNil } from 'lodash';
import { captureException } from '@sentry/browser';

import preProcessPlaybook from './pre-process-playbook';
import refreshKitConnectionSchema from './refreshKitConnectionSchema';

export default function GetPlaybooks({ integration, kit, navState, setRevision, opIndices }) {
  const selectedRevision = navState.selectedRevision;

  const selectedPlaybook = integration.playbooks.find(({ id }) => id === selectedRevision);
  const playbook = selectedPlaybook ?? integration.playbooks[0] ?? kit;
  const isSelectedRevisionMissing = !isNil(selectedRevision) && isNil(selectedPlaybook);

  const connectionJson = refreshKitConnectionSchema({
    connectionJson: playbook.connectionJson,
    kit,
    starterkitId: integration.starterkitId,
  });

  const {
    playbook: processedPlaybook,
    connection: processedConnection,
    opIndices: processedOpIndices,
  } = preProcessPlaybook(
    playbook.playbookJson,
    connectionJson,
    playbook.vars,
    playbook?.playbookJson?.metadata?.opIndices ?? opIndices
  );

  // Nothing deletes playbooks, so a missing revision means something upstream linked here wrongly.
  useEffect(() => {
    if (isSelectedRevisionMissing) {
      captureException(new Error('Playbook editor was asked to open a revision the integration does not have'), {
        extra: { integrationId: integration.id, playbookId: selectedRevision },
      });
    }
  }, [integration.id, isSelectedRevisionMissing, selectedRevision]);

  // TODO (Chris 2023.07.26) - refactor useEffect hook logic
  useEffect(() => {
    setRevision(processedPlaybook, processedConnection, playbook.id, processedOpIndices);
  }, [selectedRevision]);

  return null;
}

GetPlaybooks.propTypes = {
  integration: pt.object.isRequired,
  kit: pt.object.isRequired,
  navState: pt.shape({
    selectedRevision: pt.string,
    selectedSection: pt.string,
  }).isRequired,
  setRevision: pt.func.isRequired,
  location: pt.object,
  opIndices: pt.object.isRequired,
};
